var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaransaviRightWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,15.8c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7L28.7,0.6c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7 L12.3,15.7C12.2,15.7,12.1,15.8,12,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,29.2c-0.1,0-0.2,0-0.3-0.1L11.7,15.7c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l17.1,13.5 c0.2,0.2,0.2,0.5,0.1,0.7C29.3,29.2,29.2,29.2,29.1,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29h28V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26.5h-14V3.2h14V26.5z M13.3,25.6h12.3V4.1H13.3V25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,26.8H2.6V3.1h4.5V26.8z M3.6,25.8h2.6V4.1H3.6V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,29.7c-0.3,0-0.5-0.2-0.5-0.5V0.9c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.3C10.5,29.5,10.3,29.7,10,29.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 11.3,
    width: 3.5,
    height: 8.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaransaviRightWin);
export default __webpack_public_path__ + "static/media/faransavi_right_win.be06d3c2e4c1213d81776fbcff68f33a.svg";
export { ForwardRef as ReactComponent };